import { render, staticRenderFns } from "./SubmissionFooterNav.vue?vue&type=template&id=45291d22"
import script from "./SubmissionFooterNav.vue?vue&type=script&lang=js"
export * from "./SubmissionFooterNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports